/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
export const RestrictedAccess = ({size, ...props}) => (
  <svg viewBox="0 0 120 120" fill="currentColor" width={ size || "120" } height={ size || "120" } {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0H120V120H0z" />
      <path fill="#FFB6AC" d="M108.52 96.33L11.52 96.33 11.52 31.66 108.52 31.66z" fillRule="nonzero" />
      <path fill="#D72E15" d="M108.51 31.97L11.51 31.97 11.51 26.33 108.51 26.33z" fillRule="nonzero" />
      <path fill="#FFF" d="M78.55 86.33v1h-39v-1h39zm.07-4v1h-39v-1h39zm-10.69-4v1H50.45v-1h17.48zm26.42-37l-.51 29h-69l.51-29h69zM19.443 28.222c.547-.07 1.045.29 1.112.804.066.515-.324.99-.872 1.06-.547.071-1.045-.289-1.112-.804-.066-.515.324-.99.872-1.06zm3.997-.003c.547-.07 1.045.29 1.112.805.066.514-.324.99-.871 1.06-.548.07-1.046-.29-1.113-.804-.066-.515.324-.99.872-1.06zm-8.004-.005c.547-.07 1.045.29 1.112.804.066.515-.324.99-.872 1.06-.547.072-1.045-.288-1.112-.803-.066-.515.324-.99.872-1.06z"
        fillRule="nonzero" />
      <g stroke="#D72E15" transform="translate(42 38.33)" fillRule="nonzero">
        <circle cx="18" cy="18" r="16" strokeWidth="4" />
        <path fill="#D72E15" d="M2.793 16.504H33.213V19.504H2.793z" transform="scale(1 -1) rotate(-45.47 -24.963 0)" strokeWidth="2" />
      </g>
    </g>
  </svg>
);
RestrictedAccess.displayName = 'RestrictedAccess';
RestrictedAccess.propTypes = {
  size: PropTypes.string
}
/* tslint:enable */
/* eslint-enable */
